// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  api_url: 'https://pp.api.impekkable.com',
  stripe: {
    publicKey:
      'pk_test_51PveEGRxGGAScQNldrgfZYmKKTNAfFXPQLZlhCimkEL9HHs50vpYQRPIsErhUXewpBVDEm4AEVRc0Q59jYNbabId00EXOkOk3h',
  },
  firebase: {
    apiKey: 'AIzaSyCLYmVYknJT1e2FKT8Lpmeg4XHpqsZ07Wg',
    authDomain: 'pp-impekkable-client.firebaseapp.com',
    projectId: 'pp-impekkable-client',
    storageBucket: 'pp-impekkable-client.firebasestorage.app',
    messagingSenderId: '662524872554',
    appId: '1:662524872554:web:8cbf06051ac7633aee0713',
    measurementId: 'G-QWN084K6YS',
  },
  dbr_js_licence:
    'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTAzNjg4MjgwLVRYbFhaV0pRY205cSIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21kbHMuZHluYW1zb2Z0b25saW5lLmNvbS8iLCJvcmdhbml6YXRpb25JRCI6IjEwMzY4ODI4MCIsInN0YW5kYnlTZXJ2ZXJVUkwiOiJodHRwczovL3NkbHMuZHluYW1zb2Z0b25saW5lLmNvbS8iLCJjaGVja0NvZGUiOi0xNzI5MjgyMjQwfQ==',
  gtm: 'GTM-WQD2SL9H',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
